/**
 * @auth 赖传峰
 * @date 2024/8/30
 * @desc 打开一级目录时，自动定位到二级目录
 */
import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useLocalePath,
} from '#imports'
import useHelpCenterNavigation from '~/composables/useHelpCenterNavigation'
import removeLocaleFromPath from '~/utils/removeLocaleFromPath'
import removeTrailingSlash from '~/utils/removeTrailingSlash'

export default defineNuxtRouteMiddleware(async to => {
  const navigation = await useHelpCenterNavigation()
  // eslint-disable-next-line max-len
  const secondDirPath = navigation.value?.find(el => el._path === removeTrailingSlash(removeLocaleFromPath(to.path)))?.children?.[0]._path
  if (secondDirPath) {
    const localePath = useLocalePath()
    return navigateTo(localePath(secondDirPath))
  }
})
